import ProgressBarSteps from '../../../util/progress-bar/ProgressBarSteps'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { REGISTRATION_STAGES } from '../../../../misc/Constants'
import { selectCompletedRegistrationStages } from '../../../../reducers/programRegistrationReducer'

const RegistrationStepsProgressBar = () => {
  const completedStages = useSelector(selectCompletedRegistrationStages)
  const { t } = useTranslation()

  return (
    <ProgressBarSteps
      currentStep={completedStages}
      stepsNumber={REGISTRATION_STAGES.length}
      stepNames={REGISTRATION_STAGES.map(name => t(`programs.registration.steps.${name}`))}
    />
  )
}

export default RegistrationStepsProgressBar
